import { useCallback } from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import { useDispatch } from 'react-redux';

import { useRouter } from 'next/router';
import { setStoreLoading } from '../../../store/market/actions';
import styles from './index.module.scss';

const Tags = ({ data, setCurrentPage }) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const urlParams = router.pathname.split('/')[3].split('-');

  const renderTags = useCallback(
    (tag, index) => (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
      <div
        className={styles.tagsBlock}
        key={index}
        onClick={() => {
          setCurrentPage(1);
          dispatch(setStoreLoading());
        }}
      >
        <Link
          href={`/immobilien/${tag.urlpath}/${urlParams[0]}-${urlParams[1]}`}
        >
          <a className={styles.link}>{tag.title}</a>
        </Link>
      </div>
      // eslint-disable-next-line react-hooks/exhaustive-deps
    ),
    [urlParams, setCurrentPage],
  );

  return (
    <div className="d-flex justify-content-start flex-wrap">
      {data.map((tag, index) => renderTags(tag, index))}
    </div>
  );
};

Tags.propTypes = {
  data: PropTypes.array,
  setCurrentPage: PropTypes.func,
};

Tags.defaultProps = {
  data: [],
  setCurrentPage: () => 1,
};

export default Tags;
